export default __webpack_public_path__ + "static/media/forgotBg.d4e4ae57.jpg";